/* ============
 * Getters for the admin-rules module
 * ============
 *
 * The getters that are available on the
 * admin-rules module.
 */

export default {};



// WEBPACK FOOTER //
// ./src/store/modules/admin-rules/getters.js